import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ContentTop } from "common/src/component/ContentTop";
import { withRouter } from "react-router";
import { ReactComponent as ABCimg } from "./../data/img/abc_logo_img.svg";
import {
  AttachmentImg,
  AccountContainer,
  PageContent,
  PageContentWrapper,
  TextPage,
} from "common/src/styledComponents/AccountPage";

const Bonus = ({ pages, titles, skin, player, serverSetup }) => {
  const { t } = useTranslation();

  const isUK =
    player && player.country === "gb"
      ? true
      : serverSetup.geoIP.isoCode.toLowerCase() === "gb"
      ? true
      : false;

  useEffect(() => {
    // console.log(titles)
    document.title = titles["bonus"];
  }, [titles]);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    scrollToTop();
  }, []);

  return (
    <>
      <ContentTop
        showProfileMenu={false}
        skin={skin}
        pages={pages}
        title={t("label_bonus_header")}
      />
      <PageContent>
        <AttachmentImg left>
          <ABCimg />
        </AttachmentImg>
        <PageContentWrapper>
          <AccountContainer>
            <TextPage terms>
              <div
                dangerouslySetInnerHTML={{
                  __html: isUK ? t("text_bonus_terms_uk_in") : t("text_bonus"),
                }}
              />
            </TextPage>
          </AccountContainer>
        </PageContentWrapper>
        <AttachmentImg right>
          <ABCimg />
        </AttachmentImg>
      </PageContent>
    </>
  );
};

export default withRouter(Bonus);
